import { generatePath, matchPath } from 'react-router-dom'
import { IResponse, IFileDownloadResponse } from '@common/interfaces/request'
import { Action } from 'redux'
import { takeEvery, put, call } from 'redux-saga/effects'
import { ROUTES } from '../../constants/routes'
import { download } from '../../helpers/helpers'
import { putPromise } from '../../helpers/redux'
import { updateCheck } from '../collections/actions'
import { sagaNavigate } from '../navigationHelper'
import {
  ADD_ENTITY_INFO_SUCCESS,
  UPDATE_ENTITY_INFO_SUCCESS,
  EXPORT_CUSTOMERS_FAILURE,
  EXPORT_CUSTOMERS_SUCCESS,
  EXPORT_VENDORS_FAILURE,
  EXPORT_VENDORS_SUCCESS,
  EXPORT_INVESTORS_SUCCESS,
  EXPORT_INVESTORS_FAILURE,
} from './actions'

export function* addEntitySuccess() {
  yield takeEvery(
    [ADD_ENTITY_INFO_SUCCESS],
    function* (
      action: IResponse &
        Action & {
          checkId: string
          accountNumber: string
          data: { debtor: string }
        },
    ) {
      const { checkId, accountNumber } = action
      const { debtor } = action.data as { debtor: string }
      if (checkId) {
        yield putPromise(updateCheck(checkId, { debtor, accountNumber }))
      }
    },
  )
}

export function* updateEntityInfoSuccess() {
  yield takeEvery([UPDATE_ENTITY_INFO_SUCCESS], function* (action: IResponse & Action) {
    const data = action.data as { data: { id: string } }
    const { id } = data.data
    const path = window.location.pathname
    if (matchPath({ path: ROUTES.ENTITY_PAGE }, path)) {
      yield call(sagaNavigate, generatePath(ROUTES.ENTITY_PAGE, { id }))
    }
    if (matchPath({ path: ROUTES.ENTITY_SETTINGS_GENERAL }, path)) {
      yield call(sagaNavigate, generatePath(ROUTES.ENTITY_SETTINGS_GENERAL, { id }))
    }
  })
}

export function* exportCustomerAggregation() {
  yield takeEvery(EXPORT_CUSTOMERS_SUCCESS, function* (action: IFileDownloadResponse & Action) {
    try {
      const data = action.data
      yield download(data, data.name)
    } catch (error) {
      yield put({ type: EXPORT_CUSTOMERS_FAILURE, error: error as Error })
    }
  })
}

export function* exportVendorAggregation() {
  yield takeEvery(EXPORT_VENDORS_SUCCESS, function* (action: IFileDownloadResponse & Action) {
    try {
      const data = action.data
      yield download(data, data.name)
    } catch (error) {
      yield put({ type: EXPORT_VENDORS_FAILURE, error: error as Error })
    }
  })
}

export function* exportInvestorSummary() {
  yield takeEvery(EXPORT_INVESTORS_SUCCESS, function* (action: IFileDownloadResponse & Action) {
    try {
      const data = action.data
      yield download(data, data.name)
    } catch (error) {
      yield put({ type: EXPORT_INVESTORS_FAILURE, error: error as Error })
    }
  })
}
